import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
export class TicketControl {
    public numTck: number;
    public dtTckEnd: NgbDate;
    public dtTckEndIso: string;
    public comments: string;
}

